// // // customerSlice.js
// // import { createSlice } from "@reduxjs/toolkit";

// // const initialState = {
// //   info: localStorage.getItem("info")
// //     ? JSON.parse(localStorage.getItem("info"))
// //     : null,
// // };

// // const customerSlice = createSlice({
// //   name: "frontendAuth",
// //   initialState,
// //   reducers: {
// //     setCustomer: (state, action) => {
// //       state.info = action.payload;
// //       localStorage.setItem("info", JSON.stringify(action.payload));
// //     },
// //     logout: (state, action) => {
// //       state.info = null;
// //       localStorage.clear();
// //     },
// //   },
// // });

// // export const { setCustomer, logout } = customerSlice.actions;

// // export default customerSlice.reducer;

// // customerSlice.js
// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   info: localStorage.getItem("info")
//     ? JSON.parse(localStorage.getItem("info"))
//     : null,
// };

// const customerSlice = createSlice({
//   name: "frontendAuth",
//   initialState,
//   reducers: {
//     setCustomer: (state, action) => {
//       state.info = action.payload;
//       localStorage.setItem("info", JSON.stringify(action.payload));
//     },
//     logout: (state) => {
//       state.info = null;
//       localStorage.removeItem("info");
//     },
//   },
// });

// export const { setCustomer, logout } = customerSlice.actions;

// export default customerSlice.reducer;

// src/slices/customerSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  info: localStorage.getItem("info")
    ? JSON.parse(localStorage.getItem("info"))
    : null,
  token: localStorage.getItem("token") || null,
};

const customerSlice = createSlice({
  name: "frontendAuth", // ✅ Matches store.js
  initialState,
  reducers: {
    setCustomer: (state, action) => {
      state.info = action.payload;
      state.token = action.payload.token;
      localStorage.setItem("info", JSON.stringify(action.payload));
      localStorage.setItem("token", action.payload.token);
    },
    logout: (state) => {
      state.info = null;
      state.token = null;
      localStorage.clear();
    },
  },
});

export const { setCustomer, logout } = customerSlice.actions;

export default customerSlice.reducer;
